import { ScrollArea } from '@/components/ui/scroll-area'
import { useFormBuilderStore } from '@/stores/formBuilderStore'
import { FileQuestion } from 'lucide-react'
import { BuilderMainPreview } from './BuilderMainPreview'

type QuestionEditorProps = {
  onOpenFullPreview?: () => void
}

export function QuestionEditor({ onOpenFullPreview }: QuestionEditorProps) {
  const questions = useFormBuilderStore((state) => state.questions)
  const selectedQuestionId = useFormBuilderStore((state) => state.selectedQuestionId)
  const activeTab = useFormBuilderStore((state) => state.activeTab)
  const question = questions.find((item) => item.id === selectedQuestionId)

  if (activeTab === 'appearance') {
    return (
      <ScrollArea className="h-full min-h-0" viewportClassName="p-6">
        <BuilderMainPreview context="appearance" onOpenFullPreview={onOpenFullPreview} />
      </ScrollArea>
    )
  }

  if (!question) {
    return (
      <ScrollArea className="h-full min-h-0" viewportClassName="p-8">
        <div className="grid min-h-full place-items-center text-center">
          <div>
            <FileQuestion className="mx-auto size-12 text-slate-300" />
            <h2 className="mt-4 text-lg font-semibold">選取左側問題開始編輯</h2>
            <p className="mt-2 text-sm text-slate-500">也可以新增問題後立即進入設定。</p>
            <div className="mt-6 w-[min(760px,calc(100vw-4rem))]">
              <BuilderMainPreview
                context={activeTab}
                variant="inline"
                onOpenFullPreview={onOpenFullPreview}
              />
            </div>
          </div>
        </div>
      </ScrollArea>
    )
  }

  return (
    <ScrollArea className="h-full min-h-0" viewportClassName="p-6">
      <div className="mx-auto w-full max-w-5xl">
        <BuilderMainPreview
          context={activeTab}
          variant="inline"
          onOpenFullPreview={onOpenFullPreview}
        />
      </div>
    </ScrollArea>
  )
}
